import React from 'react';
import FooterOne from '../../Footer/FooterOne';
import Header from '../../Header/HeaderOne';
import AboutOne from '../../HomeOne/AboutOne/AboutOne';
import BannerOne from '../../HomeOne/BannerOne/BannerOne';
import { pageTitle } from '../../PageTitle';
import Industry from '../Industry/Industry';
import NewsArticle from '../NewsArticle/NewsArticle';
import PartnerClient from '../PartnerClient/PartnerClient';
import Product from '../Product/Product';
import Service from '../Service/Service';

const HomeOne = () => {
    pageTitle('K-EGP - Enabling technology into people and process');

    return (
        <>
            <Header />
            <BannerOne />
            <AboutOne />
            <Product />
            <Service />
            <Industry />
            <PartnerClient />
            <NewsArticle />
            <FooterOne />
        </>
    );
};

export default HomeOne;